<div class="layout-breadcrumb-container p-d-flex p-ai-center p-jc-between p-j-title-subtitle-area">
    <div class="layout-breadcrumb-left-items p-d-flex p-ai-center">
        <a href="#" class="menu-button" (click)="appMain.onMenuButtonClick($event)"
            *ngIf="appMain.isStatic() && !appMain.isMobile()">
            <i class="pi pi-bars"></i>
        </a>
        <!--<p-breadcrumb [model]="items" styleClass="layout-breadcrumb p-py-2"></p-breadcrumb>-->

        <a href="#" class="topbar-menu-button" style="position:absolute;right:20px;color:#fff;"
            (click)="appMain.onMenuButtonClick($event)" *ngIf="appMain.isOverlay() || appMain.isMobile()">
            <i class="pi pi-bars"></i>
        </a>


    </div>
    <!-- <div class="layout-breadcrumb-right-items p-d-flex">
        <a tabindex="0" class="search-icon" (click)="appMain.searchActive = true; appMain.searchClick = true;">
            <i class="pi pi-search"></i>
        </a>
        <button pButton pRipple type="button" label="Today" icon="pi pi-bookmark" *ngIf="!appMain.isMobile()"
                class="layout-rightmenu-button" (click)="appMain.onRightMenuButtonClick()"></button>
    </div> -->
</div>